import { actions } from "./Reducer";
/**
 * Actions that fire saga watchers
 */

// singular
export const getCustomerAction = (customerId) => ({
  type : actions.GET_CUSTOMER ,
  payload : customerId
})

export const createCustomerAction = (formData, noRedirect) => ({
  type: actions.CREATE_CUSTOMER,
  payload: formData,
  noRedirect
});

export const updateCustomerAction = (id, formData) => ({
  type: actions.UPDATE_CUSTOMER,
  payload: {
    id,
    formData,
  },
});


export const updateCustomerLimitAction = (body) => ({
  type: actions.UPDATE_CUSTOMER_LIMIT,
  payload: body
})


export const deleteCustomerAction = (id) => ({
  type: actions.DELETE_CUSTOMER,
  payload: id,
});

// Plural
export const getCustomersAction = (body) => ({
  type: actions.GET_CUSTOMERS,
  payload: body,
});

export const getFavArtisanProductsAction = (customerId) => ({
  type: actions.GET_FAV_ARTISAN_PRODUCTS,
  payload: customerId
})

export const getFavSupplierProductsAction = (customerId) => ({
  type: actions.GET_FAV_SUPPLIER_PRODUCTS,
  payload: customerId
})

export const addFavArtisanProductAction = (customerId,ProductID) => ({
  type: actions.ADD_FAV_ARTISAN_PRODUCTS,
  payload: {
    customerId,
    ProductID
  }
})

export const addFavSupplierProductAction = (customerId,ProductID) => ({
  type: actions.ADD_FAV_SUPPLIER_PRODUCTS,
  payload: {
    customerId,
    ProductID
  }
})


export const remFavArtisanProductAction = (customerId,ProductID) => ({
  type: actions.REM_FAV_ARTISAN_PRODUCTS,
  payload: {
    customerId,
    ProductID
  }
})

export const remFavSupplierProductAction = (customerId,ProductID) => ({
  type: actions.REM_FAV_SUPPLIER_PRODUCTS,
  payload: {
    customerId,
    ProductID
  }
})

/**
 * Actions that are fired by redux-saga watchers
 */

// singular
export const getCustomerSuccessAction = (customer) => ({
  type : actions.GET_CUSTOMER_SUCCESS,
  payload : customer
})

export const createCustomerSuccessAction = (customer) => ({
  type: actions.CREATE_CUSTOMER_SUCCESS,
  payload: customer,
});

export const updateCustomerSuccessAction = (customer) => ({
  type: actions.UPDATE_CUSTOMER_SUCCESS,
  payload: customer,
});

// Plural
export const getCustomersSuccessAction = (customers) => ({
  type: actions.GET_CUSTOMERS_SUCCESS,
  payload: customers,
});

/**
 * Misc
 */
export const setCustomersIsLoadingAction = (isLoading) => ({
  type: actions.SET_CUSTOMERS_IS_LOADING,
  payload: isLoading,
});

export const setCustomersCountAction = (count) => ({
  type: actions.SET_CUSTOMERS_COUNT,
  payload: count,
});

export const setSearchValueAction = (value) => ({
  type: actions.SET_CUSTOMERS_SEARCH_VALUE,
  payload: value,
});
